import clientAxios from "../client";

export async function avatarShow(
    owner_id: string,
) {
    return await clientAxios.get(
        `admin/avatar/${owner_id}/show`
    );
}

export async function avatarCreate(
    owner_id: string,
    file: string
) {
    return await clientAxios.post(
        `admin/avatar/${owner_id}/create`,
        { file }
    );
}

export async function avatarPatch(
    owner_id: string,
    file: string
) {
    return await clientAxios.patch(
        `admin/avatar/${owner_id}/patch`,
        { file }
    );
}

export async function avatarUpdate(
    owner_id: string,
    file: string
) {
    return await clientAxios.put(
        `admin/avatar/${owner_id}/update`,
        { file }
    );
}

export async function avatarDelete(
    owner_id: string,
) {
    return await clientAxios.del(
        `admin/avatar/${owner_id}/delete`,
    );
}
